import rpc from '@square/dashboard-utilities/clients/rpc';
import { ExternalSubscriptionService } from '@square/dashboard-protos/models/squareup/sub2/v3/external/external_subscription_service';
export const GET_PLAN_COMPONENTS_ENDPOINT = '/api/v3/subscriptions/external/GetPlanComponents';
export const GET_PRICING_INFO_ENDPOINT = '/api/v3/subscriptions/external/GetPricingInfo';
export const GET_SUBSCRIPTION_ENDPOINT = '/api/v3/subscriptions/external/GetSubscription';
export const GET_PLAN_GROUP_ENDPOINT = '/api/v3/subscriptions/external/GetPlanGroup';
export const LIST_MERGED_SUBSCRIPTIONS_ENDPOINT = '/api/v3/subscriptions/external/ListMergedSubscriptions';
export const EXTERNAL_BATCH_CREATE_AND_CANCEL_SUBSCRIPTIONS_ENDPOINT = '/api/v3/subscriptions/external/BatchCreateAndCancelSubscriptions';
export const EXTERNAL_IS_SUBSCRIBED_TO_FEATURE_ENDPOINT = '/api/v3/subscriptions/external/IsSubscribedToFeature';
export const GET_BILLER_LOCATION_TOKEN_ENDPOINT = '/api/v3/subscriptions/external/GetBillerLocationToken';
export const LIST_AVAILABLE_BUNDLE_OFFERINGS_ENDPOINT = '/api/v3/subscriptions/external/ListAvailableBundleOfferings';
export const CREATE_BUNDLE_ENDPOINT = '/api/v3/subscriptions/external/CreateBundle';
export const CANCEL_BUNDLE_ENDPOINT = '/api/v3/subscriptions/external/CancelBundle';
export const PAUSE_SUBSCRIPTION_ENDPOINT = '/api/v3/subscriptions/external/PauseSubscription';
export const CREATE_OR_UPDATE_SUBSCRIPTION_ENDPOINT = '/api/v3/subscriptions/external/CreateOrUpdateSubscription';
export const LIST_FEATURE_STATUSES_ENDPOINT = '/api/v3/subscriptions/external/ListFeatureStatuses';
export const UPDATE_SUBSCRIPTION_ENDPOINT = '/api/v3/subscriptions/external/UpdateSubscription';
export const EXTERNAL_GET_FUTURE_SUBSCRIBED_FEATURE_DIFF_ENDPOINT = '/api/v3/subscriptions/external/GetFutureSubscribedFeatureDiff';
export default ExternalSubscriptionService.create(rpc((method, guessedUrl) => {
  // See https://prototype.sqprod.co/#/docs/squareup.sub2.service.v3.external.ExternalSubscriptionService
  // for the list of all service methods.
  switch (method) {
    case ExternalSubscriptionService.methods.ExternalGetPlanComponents:
      return GET_PLAN_COMPONENTS_ENDPOINT;
    case ExternalSubscriptionService.methods.ExternalGetPricingInfo:
      return GET_PRICING_INFO_ENDPOINT;
    case ExternalSubscriptionService.methods.ExternalGetSubscription:
      return GET_SUBSCRIPTION_ENDPOINT;
    case ExternalSubscriptionService.methods.ExternalGetPlanGroup:
      return GET_PLAN_GROUP_ENDPOINT;
    case ExternalSubscriptionService.methods.ExternalListMergedSubscriptions:
      return LIST_MERGED_SUBSCRIPTIONS_ENDPOINT;
    case ExternalSubscriptionService.methods.ExternalBatchCreateAndCancelSubscriptions:
      return EXTERNAL_BATCH_CREATE_AND_CANCEL_SUBSCRIPTIONS_ENDPOINT;
    case ExternalSubscriptionService.methods.ExternalIsSubscribedToFeature:
      return EXTERNAL_IS_SUBSCRIBED_TO_FEATURE_ENDPOINT;
    case ExternalSubscriptionService.methods.ExternalGetBillerLocationToken:
      return GET_BILLER_LOCATION_TOKEN_ENDPOINT;
    case ExternalSubscriptionService.methods.ExternalListAvailableBundleOfferings:
      return LIST_AVAILABLE_BUNDLE_OFFERINGS_ENDPOINT;
    case ExternalSubscriptionService.methods.ExternalCreateBundle:
      return CREATE_BUNDLE_ENDPOINT;
    case ExternalSubscriptionService.methods.ExternalCancelBundle:
      return CANCEL_BUNDLE_ENDPOINT;
    case ExternalSubscriptionService.methods.ExternalPauseSubscription:
      return PAUSE_SUBSCRIPTION_ENDPOINT;
    case ExternalSubscriptionService.methods.ExternalCreateOrUpdateSubscription:
      return CREATE_OR_UPDATE_SUBSCRIPTION_ENDPOINT;
    case ExternalSubscriptionService.methods.ExternalListFeatureStatuses:
      return LIST_FEATURE_STATUSES_ENDPOINT;
    case ExternalSubscriptionService.methods.ExternalUpdateSubscription:
      return UPDATE_SUBSCRIPTION_ENDPOINT;
    case ExternalSubscriptionService.methods.ExternalGetFutureSubscribedFeatureDiff:
      return EXTERNAL_GET_FUTURE_SUBSCRIBED_FEATURE_DIFF_ENDPOINT;
    default:
      return guessedUrl;
  }
}));